import React, { useContext } from 'react';
import type { Experience } from '@axiom/validation';
import {
  Gutter,
  ReadonlyTextarea,
  Accordions,
  AccordionsItem,
  AccordionsItemHeader,
  AccordionsItemSection,
  CondensedHeader,
  Brief,
} from '@axiom/ui';

import { ExperienceEditDescriptionGuidelines } from './ExperienceEditDescriptionGuidelines';
import { ExperienceEditContext } from './ExperienceEditContext';
import { ExperienceEditSectionKeys } from './experience-edit-util';

const { WORK_DETAILS, FOCUS_AREAS, SKILLS } = ExperienceEditSectionKeys;

export type ExperienceEditTipsProps = {
  experience?: Partial<Experience>;
  name?: string;
};

export const ExperienceEditTips = ({
  experience,
  name = 'EXPERIENCE_EDIT_TIPS',
}: ExperienceEditTipsProps) => {
  const { accordionState } = useContext(ExperienceEditContext);

  const show = (() => {
    const data = {
      showGuidelines: false,
      openGuidelines: false,
      showJobDesc: false,
      openJobDesc: false,
    };
    const hasDesc = !!experience?.opportunity?.position?.description;

    if (accordionState[WORK_DETAILS]) {
      data.showGuidelines = true;
      data.openGuidelines = true;
      data.showJobDesc = hasDesc;
    }

    if (
      !accordionState[WORK_DETAILS] &&
      (accordionState[FOCUS_AREAS] || accordionState[SKILLS])
    ) {
      data.showJobDesc = hasDesc;
      data.openJobDesc = true;
    }

    return data;
  })();

  return (
    <Accordions name={name}>
      {show.showGuidelines ? (
        <AccordionsItem name="GUIDELINES" expanded={show.openGuidelines}>
          <AccordionsItemHeader>
            <CondensedHeader>Guidelines</CondensedHeader>
          </AccordionsItemHeader>
          <AccordionsItemSection>
            <Gutter top="24px" />
            <ExperienceEditDescriptionGuidelines />
          </AccordionsItemSection>
        </AccordionsItem>
      ) : null}

      {show.showJobDesc ? (
        <AccordionsItem name="JOB_DESCRIPTION" expanded={show.openJobDesc}>
          <AccordionsItemHeader>
            <CondensedHeader>Job Description</CondensedHeader>
          </AccordionsItemHeader>
          <AccordionsItemSection>
            <Gutter top="24px" />
            <Brief
              briefMaxHeight="168px"
              pattern="secondary"
              name="JOB_DESC_BRIEF"
            >
              <ReadonlyTextarea
                name="position_description"
                value={experience?.opportunity?.position?.description}
                formatting="modern"
              />
            </Brief>
          </AccordionsItemSection>
        </AccordionsItem>
      ) : null}
    </Accordions>
  );
};
